import { generateInvoice, storeComment, updateStatus } from '@app/api/prImportFreeSales.api';
import {
  updateStatus as updatePreClearanceStatus,
  storeComment as storePreClearanceComment,
} from '@app/api/pre-clearance.api';
import {
  updateStatus as updateImportStatus,
  generateInvoice as generateImportInvoice,
  storeComment as storeImportComment,
} from '@app/api/import.api';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import React, { useEffect, useState } from 'react';
import RejectPopup from './RejectPopup';
import CancelPopup from './CancelPopup';
import { getDatesSet } from '@app/utils/dateSetStore';
import { notification, message } from 'antd';
import {
  updateStatus as updateFollowUpStatus,
  generateFollowUpInvoice,
  handleFollowUpFailure,
} from '@app/api/follow-up.api';
import { updateLabStatus, generateLabInvoice } from '@app/api/labs.api';
import useApiErrorHandler from '@app/components/Error/ErrorMsgHandling';
import { generateNPInvoice, updateNPStatus } from '@app/api/nominalPayments.api';
import ActionAfterFailurePopup from './followUp/ActionAfterFailurePopup';
import { useNavigate } from 'react-router-dom';

interface WorkflowButtonsProps {
  status: string | null;
  id: string | number | null;
  setStatus: React.Dispatch<React.SetStateAction<string | null>>;
  wfActions: string[] | [];
  workflowType: 'product_registration' | 'pre-clearance' | 'import' | 'follow-up' | 'lab' | 'np' | null;
  onViewInvoicesClick: any;
  failureActions: any[];
  triggerRefresh: any;
}

const LabPaymentActions = [
  'PENDING_PAYMENT_TO_PENDING_ITR',
  'PENDING_PAYMENT_TO_PENDING_SV',
  'PENDING_PAYMENT_TO_PENDING_PRODUCTION',
  'PENDING_PAYMENT_TO_PENDING_COLLECTION',
];

const NPPaymentActions = ['PENDING_PAYMENT_TO_DONE'];

const PRPaymentActions = [
  'PENDING_DOCUMENT_PAYMENT_TO_PENDING_REVIEW',
  'PENDING_PAYMENT_TO_PENDING_DO_APPROVAL',
  'PENDING_PAYMENT_TO_PENDING_VS_APPROVAL',
];

const ImportPaymentActions = ['PENDING_PAYMENT_TO_PENDING_VISIT'];
const FolloUpPaymentActions = ['PENDING_PAYMENT_TO_PENDING_VISIT'];

const productActions: Record<string, string> = {
  DRAFT_TO_PENDING_DOCUMENT: 'Create Task',
  PENDING_DOCUMENT_TO_PENDING_DOCUMENT_PAYMENT: 'Submit Documents',
  //PENDING_DOCUMENT_PAYMENT_TO_PENDING_REVIEW: 'Make Payment',
  PENDING_DOCUMENT_TO_PENDING_REVIEW: 'Submit Documents',
  PENDING_REVIEW_TO_PENDING_DOCUMENT: 'Request Resubmission',
  PENDING_REVIEW_TO_PENDING_COMMITTEE_REVIEW: 'Submit for Committee Review',
  PENDING_REVIEW_TO_PENDING_DVRA_APPROVAL: ' Submit for DVRA Approval',
  PENDING_COMMITTEE_REVIEW_TO_PENDING_DOCUMENT: 'Resubmit Documents for Review',
  PENDING_DVRA_APPROVAL_TO_PENDING_DOCUMENT: 'Resubmit Documents for Review',
  PENDING_COMMITTEE_REVIEW_TO_REJECTED: 'Reject',
  PENDING_DVRA_APPROVAL_TO_REJECT: 'Reject',
  PENDING_DVRA_APPROVAL_TO_PENDING_VISIT: 'Approve for 1st Site Visit',
  PENDING_VISIT_TO_REJECT: 'Reject Task',
  PENDING_VISIT_TO_PENDING_DVRA_FINAL_APPROVAL: 'Request for DVRA Approval',
  PENDING_VISIT_TO_PENDING_SECOND_VISIT: 'Approve for 2nd Site Visit',
  PENDING_SECOND_VISIT_TO_REJECT: 'Reject Task',
  PENDING_SECOND_VISIT_TO_PENDING_THRID_VISIT: 'Approve for 3rd Site Visit',
  PENDING_THIRD_VISIT_TO_REJECT: 'Reject Task',
  PENDING_THIRD_VISIT_TO_PENDING_DVRA_FINAL_APPROVAL: 'Request for 2nd DVRA Approval',
  PENDING_DVRA_FINAL_APPROVAL_TO_PENDING_PAYMENT: 'Approve for Payment',
  REJECTED_TO_CANCELED: 'Cancel Request',
  PENDING_COMMITTEE_REVIEW_TO_PENDING_PAYMENT: 'Proceed to Payment',
  PENDING_DVRA_FINAL_APPROVAL_TO_PENDING_VS_APPROVAL: 'Submit for VS Approval',
  PENDING_PAYMENT_TO_PENDING_DO_APPROVAL: 'Submit for DO Approval',
  PENDING_COMMITTEE_REVIEW_TO_PENDING_DO_APPROVAL: 'Submit for DO Approval',
  PENDING_DO_APPROVAL_TO_PENDING_REGISTRAR_APPROVAL: 'Submit for Registrar Approval',
  PENDING_VS_APPROVAL_TO_PENDING_CERTIFICATE_COLLECTION: 'Proceed to Certificate Collection',
  PENDING_REGISTRAR_APPROVAL_TO_PENDING_CERTIFICATE_COLLECTION: 'Proceed to Certificate Collection',
  PENDING_CERTIFICATE_COLLECTION_TO_DONE: 'Complete Registration',
};

const preClearanceActions: Record<string, string> = {
  DRAFT_TO_PENDING_DOCUMENT: 'Create Task',
  PENDING_DOCUMENT_TO_PENDING_REVIEW: 'Submit Documents',
  PENDING_REVIEW_TO_PENDING_DOCUMENT: 'Resubmit Documents',
  PENDING_REVIEW_TO_CANCEL: 'Cancel Request',
  PENDING_REVIEW_TO_PENDING_PRE_APPROVAL: 'Submit for Pre-Approval',
  PENDING_PRE_APPROVAL_TO_PENDING_APPROVAL: 'Submit for Approval',
  PENDING_APPROVAL_TO_DONE: 'Complete Process',
};

const importActions: Record<string, string> = {
  DRAFT_TO_PENDING_DOCUMENT: 'Create Task',
  PENDING_DOCUMENT_TO_PENDING_DG: 'Submit Documents for DG Approval',
  PENDING_VERIFICATION_AQO_TO_PENDING_DOCUMENT: 'Request Document Resubmission',
  PENDING_VERIFICATION_AQO_TO_PENDING_DIRECTOR_APPROVAL: 'Submit for DA',
  PENDING_DIRECTOR_APPROVAL_TO_PENDING_DG_APPROVAL: 'Submit for DG Approval',
  PENDING_DIRECTOR_APPROVAL_TO_REJECTED: 'Reject',
  PENDING_DIRECTOR_APPROVAL_TO_PENDING_VERIFICATION_AQO: 'Send Back to AQO',
  PENDING_DG_APPROVAL_TO_REJECTED: 'Reject',
  PENDING_DG_APPROVAL_TO_PENDING_DIRECTOR_APPROVAL: 'Send Back to DA',
  PENDING_DG_APPROVAL_TO_PENDING_VERIFICATION_AQO_SUB: 'Send Back to AQO',
  PENDING_VERIFICATION_AQO_TO_REJECTED: 'Reject',
  PENDING_DG_TO_PENDING_VERIFICATION_AQO: 'Verify Document after DG Approval',
  PENDING_DG_TO_PENDING_DOCUMENT: 'Request Document Resubmission',
  PENDING_DOCUMENT_TO_PENDING_VERIFICATION_AQO: 'Submit Documents for AQO Verification',
  PENDING_CUSTOMER_VISIT_TO_PENDING_DIRECTOR_APPROVAL: 'Submit for DA',
  PENDING_CUSTOMER_VISIT_TO_REJECTED: 'Reject',
  PENDING_DIRECTOR_APPROVAL_TO_PENDING_CUSTOMER_VISIT: 'Schedule Customer Visit',
  PENDING_DG_APPROVAL_TO_PENDING_CUSTOMER_VISIT: 'Schedule Customer Visit',
  PENDING_VERIFICATION_AQO_TO_PENDING_CUSTOMER_VISIT: 'Verify Documents & Schedule Customer Visit',
  PENDING_VERIFICATION_AQO_TO_COMPLETE: 'Complete Import Process',
  PENDING_CUSTOMER_VISIT_TO_PENDING_PAYMENT: 'Proceed to Payment',
  PENDING_PAYMENT_TO_PENDING_VISIT: 'Schedule Physical Visit',
  PENDING_VISIT_TO_PENDING_ADDITIONAL_DOCUMENT: 'Request Additional Document',
  PENDING_ADDITIONAL_DOCUMENT_TO_REJECTED: 'Reject',
  PENDING_ADDITIONAL_DOCUMENT_TO_PENDING_DIRECTOR_APPROVAL: 'Submit for DA',
  PENDING_ADDITIONAL_DOCUMENT_TO_PENDING_3RD_APPROVAL: 'Submit for 3rd Approval',
  PENDING_DIRECTOR_APPROVAL_TPENDING_ADDITIONAL_DOCUMENT: 'Request Additional Document',
  PENDING_DG_APPROVAL_TO_PENDING_ADDITIONAL_DOCUMENT: 'Request Additional Document',
  PENDING_3RD_APPROVAL_TO_PENDING_DIRECTOR_APPROVAL: 'Submit for DA',
  PENDING_3RD_APPROVAL_TO_PENDING_4TH_APPROVAL: 'Submit for 4th Approval',
  PENDING_3RD_APPROVAL_TO_REJECTED: 'Reject',
  PENDING_DIRECTOR_APPROVAL_TPENDING_3RD_APPROVAL: 'Submit for 3rd Approval',
  PENDING_DG_APPROVAL_TO_PENDING_3RD_APPROVAL: 'Submit for 3rd Approval',
  PENDING_4TH_APPROVAL_TO_PENDING_DIRECTOR_APPROVAL: 'Submit for DA',
  PENDING_4TH_APPROVAL_TO_PENDING_CUSTOMS: 'Submit for Customs Approval',
  PENDING_4TH_APPROVAL_TO_REJECTED: 'Reject',
  PENDING_DIRECTOR_APPROVAL_TPENDING_4TH_APPROVAL: 'Submit for 4th Approval',
  PENDING_DG_APPROVAL_TO_PENDING_4TH_APPROVAL: 'Submit for 4th Approval',
  PENDING_CUSTOMS_TO_COMPLETED: 'Complete Import Process',
  PENDING_CUSTOMS_TO_REJECTED: 'Reject',
  PENDING_VERIFICATION_AQO_TO_COMPLETED: 'Complete Process',
  PENDING_DOCUMENT_TO_PENDING_DG_APPROVAL: 'Submit for DGA',
  PENDING_DG_APPROVAL_TO_PENDING_DOCUMENT: 'Request Document Resubmission',
  PENDING_DG_APPROVAL_TO_PENDING_VERIFICATION_AQO: 'Request AQO Verification',
};
const followUpActions: Record<string, string> = {
  DRAFT_TO_PENDING_PAYMENT: 'Proceed to Payment',
  PENDING_PAYMENT_TO_PENDING_VISIT: 'Schedule Visit',
  PENDING_VISIT_TO_PENDING_DOCUMENT: 'Proceed to Document Submisssion',
  PENDING_DOCUMENT_TO_PENDING_APPROVAL: 'Submit Documents',
  PENDING_PAYMENT_TO_PENDING_DOCUMENT: 'Submit Documents',
  PENDING_DOCUMENT_TO_PENDING_DG: 'Submit for DG Approval',
  PENDING_DG_TO_PENDING_VISIT: 'Schedule Visit',
  PENDING_VISIT_TO_PENDING_CERT_APPROVAL: 'Submit for Certificate Approval',
  PENDING_CERT_APPROVAL_TO_PENDING_LDO_APPROVAL: 'Submit for LDO Approval',
  PENDING_LDO_APPROVAL_TO_PENDING_ADDITIONAL_DOCUMENT: 'Request Additional Documents',
  PENDING_ADDITIONAL_DOCUMENT_TO_PENDING_CUSTOMS: 'Submit for Customs Approval',
  PENDING_APPROVAL_TO_DONE: 'Complete Follow Up',
  PENDING_APPROVAL_TO_FAIL: 'Reject Follow Up',
  PENDING_CUSTOMS_TO_COMPLETE: 'Complete Process',
  ANY_TO_REJECTED: 'Reject Request',
};

const labActions: Record<string, string> = {
  DRAFT_TO_PENDING_TA: 'Create Task',
  PENDING_TA_TO_PENDING_PAYMENT: 'Approve Test Assignments',
  // PENDING_PAYMENT_TO_PENDING_ITR: 'Make Payment',
  // PENDING_PAYMENT_TO_PENDING_SV: 'Make Payment',
  PENDING_SV_TO_PENDING_ITR: 'Submit for Test Results',
  PENDING_ITR_TO_PENDING_ITRA: 'Submit for Result Approval',
  PENDING_ITRA_TO_PENDING_ITR: 'Reject Results',
  PENDING_ITRA_TO_PENDING_FRS: 'Approve Initial Results',
  PENDING_PRODUCTION_TO_PENDING_FA: 'Submit for Final Approval',
  PENDING_FRS_TO_PENDING_FA: 'Submit for Final Results',
  PENDING_FA_TO_DONE: 'Approve Final Results',
  DRAFT_TO_PENDING_MA: 'Create Task',
  PENDING_MA_TO_PENDING_PAYMENT: 'Approve Vaccines',
  PENDING_FA_TO_PENDING_COLLECTION: 'Submit to Pending Collection',
  // PENDING_PAYMENT_TO_PENDING_PRODUCTION: 'Make Payment',
  DRAFT_TO_PENDING_IA: 'Create Task',
  PENDING_IA_TO_PENDING_PAYMENT: 'Approve Products',
  PENDING_COLLECTION_TO_DONE: 'Complete',
  // PENDING_PAYMENT_TO_PENDING_COLLECTION: 'Make Payment',
};

const npActions: Record<string, string> = {
  DRAFT_TO_PENDING_PAYMENT: 'Create Task',
  //PENDING_PAYMENT_TO_DONE: 'Make Payment', // remove after invoice is complete
};

const PopupActions = [
  'PENDING_COMMITTEE_REVIEW_TO_REJECTED',
  'PENDING_DIRECTOR_APPROVAL_TO_REJECTED',
  'PENDING_VERIFICATION_AQO_TO_PENDING_DIRECTOR_APPROVAL',
  'PENDING_DIRECTOR_APPROVAL_TO_PENDING_DG_APPROVAL',
  'PENDING_DIRECTOR_APPROVAL_TO_PENDING_VERIFICATION_AQO',
  'PENDING_DG_APPROVAL_TO_REJECTED',
  'PENDING_DG_APPROVAL_TO_PENDING_DIRECTOR_APPROVAL',
  'PENDING_DG_APPROVAL_TO_PENDING_VERIFICATION_AQO_SUB',
  'PENDING_VERIFICATION_AQO_TO_REJECTED',
  'PENDING_DG_TO_PENDING_DOCUMENT',
  'PENDING_CUSTOMER_VISIT_TO_PENDING_DIRECTOR_APPROVAL',
  'PENDING_CUSTOMER_VISIT_TO_REJECTED',
  'PENDING_DIRECTOR_APPROVAL_TO_PENDING_CUSTOMER_VISIT',
  'PENDING_ADDITIONAL_DOCUMENT_TO_PENDING_DIRECTOR_APPROVAL',
  'PENDING_ADDITIONAL_DOCUMENT_TO_REJECTED',
  'PENDING_DIRECTOR_APPROVAL_TPENDING_ADDITIONAL_DOCUMENT',
  'PENDING_DG_APPROVAL_TO_PENDING_ADDITIONAL_DOCUMENT',
  'PENDING_3RD_APPROVAL_TO_PENDING_DIRECTOR_APPROVAL',
  'PENDING_3RD_APPROVAL_TO_REJECTED',
  'PENDING_DG_APPROVAL_TO_PENDING_3RD_APPROVAL',
  'PENDING_4TH_APPROVAL_TO_PENDING_DIRECTOR_APPROVAL',
  'PENDING_4TH_APPROVAL_TO_REJECTED',
  'PENDING_DIRECTOR_APPROVAL_TPENDING_4TH_APPROVAL',
  'PENDING_DG_APPROVAL_TO_PENDING_4TH_APPROVAL',
  'PENDING_CUSTOMS_TO_REJECTED',
  //'PENDING_DOCUMENT_TO_PENDING_DG_APPROVAL_',
];

const WorkflowButtons: React.FC<WorkflowButtonsProps> = ({
  status,
  id,
  wfActions,
  setStatus,
  workflowType,
  onViewInvoicesClick,
  failureActions,
  triggerRefresh,
}) => {
  const [isRejectModalVisible, setRejectModalVisible] = useState(false);
  const [isCancelModalVisible, setCancelModalVisible] = useState(false);
  const [isFailureModalVisible, setFailureModalVisible] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [pendingAction, setPendingAction] = useState<string | null>(null);
  const navigate = useNavigate();
  const [popupTitle, setPopupTitle] = useState('Action');

  // Get the user name from local storage
  const user = localStorage.getItem('user');
  const username = user ? JSON.parse(user).name : null;
  const handleErrorMessages = useApiErrorHandler();

  useEffect(() => {
    console.log('Status changed:', status);
    console.log('Updated wfActions:', wfActions);
  }, [status, wfActions]);

  if (!status || !id || !wfActions || wfActions.length === 0) return null;

  const actionLabels =
    workflowType === 'product_registration'
      ? productActions
      : workflowType === 'pre-clearance'
      ? preClearanceActions
      : workflowType === 'import'
      ? importActions
      : workflowType === 'lab'
      ? labActions
      : workflowType === 'np'
      ? npActions
      : followUpActions;

  const handleWorkflowAction = async (action: string) => {
    if (workflowType === 'pre-clearance' && action === 'PENDING_REVIEW_TO_CANCEL' && username === 'Admin') {
      setCancelModalVisible(true);
      setPendingAction(action);
      return;
    }

    // if (action === 'PENDING_COMMITTEE_REVIEW_TO_REJECTED') {
    //   setRejectModalVisible(true);
    //   setPendingAction(action);
    //   return;
    // }

    if (PopupActions.includes(action)) {
      setPendingAction(action);
      setPopupTitle(actionLabels[action] || 'Action');
      setRejectModalVisible(true);
      return;
    }

    if (workflowType === 'follow-up' && action === 'PENDING_APPROVAL_TO_FAIL') {
      setPendingAction(action);
      setFailureModalVisible(true);
      return;
    }

    // if (
    //   action === 'PENDING_COMMITTEE_REVIEW_TO_PENDING_PAYMENT' ||
    //   action === 'PENDING_DVRA_FINAL_APPROVAL_TO_PENDING_PAYMENT'
    // ) {
    //   const isDatesSet = getDatesSet();
    //   console.log('DateSet Value: ', isDatesSet);
    //   if (!isDatesSet) {
    //     notification.error({
    //       message: 'Cannot Proceed',
    //       description: 'Please set Certificate Validity Dates before continuing.',
    //     });
    //     return;
    //   }

    //   try {
    //     await generateInvoice(Number(id), 'CERTIFICATE');
    //   } catch (error) {
    //     console.error('Error generating invoice:', error);
    //     return;
    //   }
    // }

    // if (action === 'PENDING_DOCUMENT_TO_PENDING_DOCUMENT_PAYMENT') {
    //   try {
    //     await generateInvoice(Number(id), 'APPLICATION');
    //   } catch (error) {
    //     console.error('Error generating invoice:', error);
    //     return;
    //   }
    // }

    // if (workflowType === 'import' && action === 'PENDING_CUSTOMER_VISIT_TO_PENDING_PAYMENT') {
    //   try {
    //     await generateImportInvoice(Number(id), 'IMPORT');
    //   } catch (error) {
    //     console.error('Error generating import invoice:', error);
    //     return;
    //   }
    // }

    // if (workflowType === 'np' && action === 'DRAFT_TO_PENDING_PAYMENT') {
    //   try {
    //     await generateNPInvoice(Number(id));
    //   } catch (error) {
    //     console.error('Error generating NP invoice:', error);
    //     return;
    //   }
    // }

    // if (
    //   (workflowType === 'lab' && action === 'PENDING_MA_TO_PENDING_PAYMENT') ||
    //   action === 'PENDING_VISIT_TO_PENDING_PAYMENT' ||
    //   // action === 'PENDING_PAYMENT_TO_PENDING_SV' ||
    //   // action === 'PENDING_PAYMENT_TO_PENDING_ITR' ||
    //   action === 'PENDING_TA_TO_PENDING_PAYMENT'
    // ) {
    //   try {
    //     await generateLabInvoice(Number(id), 'LAB');
    //     message.success('Lab invoice generated successfully.');
    //   } catch (error) {
    //     console.error('Error generating lab invoice:', error);
    //     message.error('Failed to generate lab invoice.');
    //     return;
    //   }
    // }

    await handleStatusChange(action);
  };

  const handleStatusChange = async (action: string) => {
    try {
      if (workflowType === 'pre-clearance') {
        await updatePreClearanceStatus(Number(id), { action });
      } else if (workflowType === 'import') {
        await updateImportStatus(Number(id), { action });
        if (action === 'PENDING_CUSTOMER_VISIT_TO_PENDING_PAYMENT') {
          try {
            console.log('Calling generateImportInvoice...');
            await generateImportInvoice(Number(id), 'IMPORT');
            message.success('Import invoice generated successfully.');
          } catch (error) {
            console.error('Error generating Import invoice:', error);
            message.error('Failed to generate Import invoice.');
          }
        }
        console.log(`Status updated to: ${action}`);
        setStatus(action);
      } else if (workflowType === 'follow-up') {
        console.log('workflowType matched: follow-up, action:', action);
        await updateFollowUpStatus(Number(id), { action });
        if (action === 'DRAFT_TO_PENDING_PAYMENT') {
          try {
            console.log('Calling generateFollowUpInvoice...');
            await generateFollowUpInvoice(Number(id), 'FU');
            message.success('Follow Up invoice generated successfully.');
          } catch (error) {
            console.error('Error generating Follow Up invoice:', error);
            message.error('Failed to generate Follow Up invoice.');
          }
        }
        setStatus(action);
      } else if (workflowType === 'lab') {
        await updateLabStatus(Number(id), { action });

        if (
          action === 'PENDING_MA_TO_PENDING_PAYMENT' ||
          action === 'PENDING_VISIT_TO_PENDING_PAYMENT' ||
          action === 'PENDING_TA_TO_PENDING_PAYMENT' ||
          action === 'PENDING_IA_TO_PENDING_PAYMENT'
        ) {
          try {
            await generateLabInvoice(Number(id), 'LAB');
            message.success('Lab invoice generated successfully.');
          } catch (error) {
            console.error('Error generating lab invoice:', error);
            message.error('Failed to generate lab invoice.');
          }
        }
      } else if (workflowType === 'np') {
        if (status === 'DRAFT') {
          await updateNPStatus(Number(id), { action });

          try {
            await generateNPInvoice(Number(id));
            message.success('Nominal Payment invoice generated successfully.');
          } catch (error) {
            console.error('Error generating Nominal Payment invoice:', error);
            message.error('Failed to generate Nominal Payment invoice.');
          }
        } else {
          await updateNPStatus(Number(id), { action });
          setStatus(action);
        }
      } else {
        console.log('Current status:', status);
        console.log('Current action:', action);

        if (
          action === 'PENDING_COMMITTEE_REVIEW_TO_PENDING_PAYMENT' ||
          action === 'PENDING_DVRA_FINAL_APPROVAL_TO_PENDING_PAYMENT' ||
          action === 'PENDING_COMMITTEE_REVIEW_TO_PENDING_DO_APPROVAL' ||
          action === 'PENDING_DVRA_FINAL_APPROVAL_TO_PENDING_VS_APPROVAL' ||
          status === 'PENDING_COMMITTEE_REVIEW'
        ) {
          console.log('Entered date validation block');
          const isDatesSet = getDatesSet(Number(id));
          console.log('DateSet Value: ', isDatesSet);
          if (!isDatesSet) {
            notification.error({
              message: 'Cannot Proceed',
              description: 'Please set Certificate Validity Dates before continuing.',
            });
            return;
          }
        }

        await updateStatus(Number(id), { action });

        if (
          action === 'PENDING_COMMITTEE_REVIEW_TO_PENDING_PAYMENT' ||
          action === 'PENDING_DVRA_FINAL_APPROVAL_TO_PENDING_PAYMENT'
        ) {
          try {
            await generateInvoice(Number(id), 'CERTIFICATE');
          } catch (error) {
            console.error('Error generating invoice:', error);
            return;
          }
        }
        if (action === 'PENDING_DOCUMENT_TO_PENDING_DOCUMENT_PAYMENT') {
          try {
            await generateInvoice(Number(id), 'APPLICATION');
          } catch (error) {
            console.error('Error generating invoice:', error);
            return;
          }
        }
      }

      console.log(`Status updated to: ${action}`);
      setStatus(action);
    } catch (err: any) {
      handleErrorMessages(err);
      console.error('Error updating status:', err);

      // Handle specific error messages from updateLabStatus API
      //     if (workflowType === 'lab' && error?.response?.data) {
      //       const errorData = error.response.data;
      //       if (errorData.errors) {
      //         // Display specific error messages
      //         Object.entries(errorData.errors).forEach(([field, msg]) => {
      //           message.error(`${field}: ${msg}`, 4);
      //         });
      //       } else if (errorData.message) {
      //         message.error(errorData.message);
      //       } else {
      //         message.error('Failed to update lab status.');
      //       }
      //     } else {
      //       message.error('Error updating status.');
      //     }
    }
  };

  const handleRejectSubmit = async (values: { commentFor: string; comment: string }) => {
    setIsSubmitting(true);
    try {
      const newComment = {
        comment_for: values.commentFor,
        comment: values.comment,
      };

      if (pendingAction === 'PENDING_COMMITTEE_REVIEW_TO_REJECTED') {
        const res = await storeComment(Number(id), newComment);
        if (!res?.data) return;
      } else {
        await storeImportComment(Number(id), newComment);
      }

      setRejectModalVisible(false);
      if (pendingAction) {
        await handleStatusChange(pendingAction);
        setPendingAction(null);
      }
    } catch (error) {
      console.error('Error submitting reject comment:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancelSubmit = async (values: { commentFor: string; comment: string }) => {
    setIsSubmitting(true);
    try {
      const newComment = {
        comment_for: values.commentFor,
        comment: values.comment,
      };

      const res = await storePreClearanceComment(Number(id), newComment);

      if (res?.data) {
        console.log('Cancel comment submitted successfully:', res.data);
        setCancelModalVisible(false);

        if (pendingAction) {
          await handleStatusChange(pendingAction);
          setPendingAction(null);
        }
      }
    } catch (error) {
      console.error('Error submitting cancel comment:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleFailureSubmit = async (values: { action_after_failure: string; msg?: string; comment_for?: string }) => {
    setIsSubmitting(true);

    try {
      // 1. FIRST: status change API
      // const statusRes = await updateFollowUpStatus(Number(id), {
      //   action: pendingAction, // PENDING_APPROVAL_TO_FAIL
      // });

      // if (!statusRes) {
      //   throw new Error('Status update failed');
      // }

      // 2. SECOND: failure handling API
      const payload = {
        action_after_failure: values.action_after_failure,
        msg: values.msg || null,
        comment_for: values.comment_for || null,
      };

      const res = await handleFollowUpFailure(Number(id), payload);

      // 3. SUCCESS
      notification.success({
        message: 'Success',
        description: 'Follow-up marked as failed successfully.',
      });

      setFailureModalVisible(false);
      setPendingAction(null);

      triggerRefresh?.();

      return res;
    } catch (error) {
      console.error('Failure flow error:', error);

      notification.error({
        message: 'Error',
        description: 'Failed to process follow-up failure.',
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {wfActions.map((action) => {
        if (
          LabPaymentActions.includes(action) ||
          NPPaymentActions.includes(action) ||
          PRPaymentActions.includes(action) ||
          FolloUpPaymentActions.includes(action) ||
          ImportPaymentActions.includes(action)
        )
          return null;

        return (
          <BaseButton key={action} type="primary" size="small" onClick={() => handleWorkflowAction(action)}>
            {actionLabels[action] || 'Next Step'}
          </BaseButton>
        );
      })}

      {wfActions.some((action) => LabPaymentActions.includes(action)) && (
        <BaseButton type="primary" size="small" onClick={onViewInvoicesClick}>
          View Invoices
        </BaseButton>
      )}

      {wfActions.some((action) => NPPaymentActions.includes(action)) && (
        <BaseButton type="primary" size="small" onClick={onViewInvoicesClick}>
          View Invoices
        </BaseButton>
      )}

      {wfActions.some((action) => PRPaymentActions.includes(action)) && (
        <BaseButton type="primary" size="small" onClick={onViewInvoicesClick}>
          View Invoices
        </BaseButton>
      )}

      {workflowType === 'import' && wfActions.some((action) => ImportPaymentActions.includes(action)) && (
        <BaseButton type="primary" size="small" onClick={onViewInvoicesClick}>
          View Invoices
        </BaseButton>
      )}

      {workflowType === 'follow-up' && wfActions.some((action) => FolloUpPaymentActions.includes(action)) && (
        <BaseButton type="primary" size="small" onClick={onViewInvoicesClick}>
          View Invoices
        </BaseButton>
      )}

      <RejectPopup
        key={pendingAction || 'default'}
        title={popupTitle}
        visible={isRejectModalVisible}
        onClose={() => {
          setRejectModalVisible(false);
          setPendingAction(null);
        }}
        onSubmit={handleRejectSubmit}
        isLoading={isSubmitting}
      />

      <CancelPopup
        visible={isCancelModalVisible}
        onClose={() => {
          setCancelModalVisible(false);
          setPendingAction(null);
        }}
        onSubmit={handleCancelSubmit}
        isLoading={isSubmitting}
      />
      <ActionAfterFailurePopup
        visible={isFailureModalVisible}
        onClose={() => {
          setFailureModalVisible(false);
          setPendingAction(null);
        }}
        onSubmit={handleFailureSubmit}
        options={failureActions}
        isLoading={isSubmitting}
      />
    </>
  );
};

export default WorkflowButtons;
